module.exports = __webpack_public_path__ + "static/img/faq-icon-updated.7104d410.svg";